// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"447":"1d92789c","483":"37240bd3","641":"0e0c2161","728":"3bfb77ea"}[chunkId] + ".chunk.css";
};